import React from 'react'

function Footer() {
  
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Footer Open */}
    <footer className="footer mt-auto">
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 text-center"> 
                Copyright © {currentYear}&nbsp;UPDES.  All Rights Reserved.
                </div>
                 {/* /col */}
            </div>
             {/* /row */}
        </div>
    </footer>
      {/* Footer Close */}
      
    </>
  )
}

export default Footer